module.exports = __webpack_public_path__ + "static/img/bannerBg.9044074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bannerBg.png
// module id = KGvQ
// module chunks = 0